import _Abstract from "system/abstract"
import InputValidator from "components/input-validator-v2"

export default class Module_ContactForm extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {}, options), 'module')

    var $ctaInputForm = this.$el.find(".cta-input-form");
    if($ctaInputForm.length)
    {
      new InputValidator($ctaInputForm[0], {"submit_button_selector":".cta-input-sugarform--send-btn"});
    }

    this.initialise();
  }

  initialise()
  {
    this.$el.find("[data-responsive-image]").addClass("-no-colour-loading-bg")
    this.initListeners();
  }

  initListeners()
  {
    $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list").on("click","li", (e) => this.onCustomTickListItemClicked(e));
    $(".cta-input-sugarform--send-btn").click((e) => this.onSendFormButtonClicked(e));
  }

  onCustomTickListItemClicked(_event)
  {
    // var bOneAtATime = $(_event.currentTarget).closest(".custom-tick-list.-one-at-a-time").length >= 0;
    var $li = $(_event.currentTarget);
    // if(bOneAtATime)
    // {
      //Since we're now only triggering one at a time, lets remove the ticked modifier class on all of the li elements
      $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list li").removeClass("-ticked");
    // }

    if($li.hasClass("-ticked"))
    {
      $li.removeClass("-ticked");
    }
    else
    {
      $li.addClass("-ticked");
    }


    var bAtleastOneIsTicked = $(".cta-options-page--tick-list-next-btn-ctn .custom-tick-list > li.-ticked").length > 0;
    if(bAtleastOneIsTicked)
    {
      $(".cta-options-page .cta-page--next-page-btn").removeClass("-hide");
    }
    else
    {
      $(".cta-options-page .cta-page--next-page-btn").addClass("-hide");
    }

    //Now hide / show elements that are specific to the selected element

    $(".cta-input-form--inputs-ctn > .c-label-input-ctn").removeClass("-hide");

    if($li.hasClass("-send-email"))
    {
      //dont hide anything

      $(".thanks-page .cta-page--hero-text").html("Great to hear from you.<br class='-desktop-only' /> We’ll be in touch shortly.");

    }
    else if($li.hasClass("-sign-up-for-email"))
    {
      
      $(".thanks-page .cta-page--hero-text").html("Thanks for signing up to<br class='-desktop-only' /> our e-newsletter.<br /><br class='-desktop-only' />We’re always in the classroom learning <br />and can’t wait to share our insights with you.");
      //Hide location and comments
      $(".cta-input-form--inputs-ctn [name='Location'], .cta-input-form--inputs-ctn [name='Comments']").each(function(){

        var $this = $(this);

        $this.closest(".c-label-input-ctn").addClass("-hide");

      })
    }




  }

  onSendFormButtonClicked()
  {
    // data-component="click-behaviour" 
    //data-component-options='{"type":"hide-element-show-element","hide_target":".cta-input-form","show_target":".thanks-page"}'

    console.log('FROM - Contactform-v2 onSubmitButtonClicked');
    var tickedOptions = this.getOptionsPageValues();
    var formData = {"HelpOption":tickedOptions};

    var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
    $(".cta-input-sugarform--send-btn").after(htmlLoader);

    //Popuplate the 'form data' we're sending off with the inputs / textareas
    $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__input-wrapper > input").each(function()
    {
      formData[$(this).attr("name")] = $(this).val();
    });

    $(".cta-input-form--inputs-ctn .c-label-input-ctn:not(.-hide) .c-label-input-ctn__textarea-wrapper > textarea").each(function()
    {
      formData[$(this).attr("name")] = $(this).val();
    });


    var contactID = this.$el.find("input[name='ContactID']").val();
    if(!contactID)
    {
      alert("Error: No Contact ID Found");
      return;
    }

    formData["Contact"] = contactID;

    // console.log(formData);
    // var postURL = $(".m-contact-cta").data("send-to-url");
    // if(!postURL)
    // {
    //   alert("Error: No URL to send form data to");
    //   return;
    // }

    if(window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost")
    {
      this.onFormResponse();
      return;
    }

    // formData = JSON.stringify(formData);
    // $.ajax
    // ({
    //   type: "POST",
    //   url: postURL,
    //   dataType: 'json',
    //   headers: {
    //     "Authorization": "Basic cmVzdGFwaTpZcFhCSXlCRGJuTzBrNllwUnJJaQ=="
    //   },
    //   data: formData,
    //   error:(e) => this.onFormErrorOccurred(e),
    //   success: (e) => this.onFormResponse(e)
    // });

    // if(postURL.indexOf("contact-response.json") !== -1)
    // {
    //   $.get(postURL,formData,(e)=>this.onFormResponse(e));
    // }
    // else
    // {
    //   $.post(postURL,formData,(e)=>this.onFormResponse(e));
    // }
  }

  onFormErrorOccurred(e)
  {
    alert("An error occurred submitting the form, please try again");
  }

  onFormResponse(e)
  {
    $(".cta-input-form").addClass("-hide");
    $(".thanks-page").removeClass("-hide");
    $("body").trigger("responsive-image-check",{});


    var currentScrollTop = $(window).scrollTop();
    var offsetTopY = $(".thanks-page").offset().top;
    $("window,body").stop().animate({scrollTop:offsetTopY});


  }

  getOptionsPageValues()
  {
    var tickListOptions = "";
    
    $(".cta-options-page--tick-list-next-btn-ctn li.-ticked").each(function()
    {
      if(tickListOptions !== "")
      {
        tickListOptions += ";";
      }

      tickListOptions += $(this).find("input[type='hidden']").attr("value")
    });
    
    return tickListOptions;
  }

}



/** WEBPACK FOOTER **
 ** ./modules/contact-form-v2.js
 **/